module.exports = "/dashboard/manage/components/manageGroupHeaderComponent-1021c5.html";